import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { USER_LOGGED_IN } from "../../Reducer/authSlice";
import Login from "../../Auth/Login";
import TeacherInfo from "./TeacherInfo";
import WaitingApproval from "./WaitingApproval";
import TutorNav from "./TutorNav";
import DashMobileNav from "../../components/DashMobileNav";
import DashHeader from "../../components/DashHeader";
import { useTranslation } from "react-i18next";

const TUTOR_NAV_ITEMS = [
    { to: '/dashboard/tutor', icon: 'fa-light fa-grid-2', label: 'tutorDashboard.dashboard', end: true },
    { to: '/dashboard/chat', icon: 'fa-light fa-message-lines', label: 'tutorDashboard.messages', badge: 'unread' },
    { to: '/dashboard/my-courses', icon: 'fa-light fa-chalkboard-user', label: 'tutorDashboard.courses' },
    { to: '/dashboard/all-enrollment-courses', icon: 'fa-light fa-list', label: 'tutorDashboard.classes' },
    { to: '/dashboard/live-room', icon: 'fa-light fa-video', label: 'tutorDashboard.live_room' },
    { to: '/dashboard/earnings', icon: 'fa-light fa-wallet', label: 'tutorDashboard.earnings' },
    { to: '/dashboard/transactions', icon: 'fa-light fa-chart-bar', label: 'tutorDashboard.transactions' },
    { to: '/dashboard/withdraw', icon: 'fa-light fa-money-bill-transfer', label: 'tutorDashboard.withdraw' },
    { to: '/dashboard/settings', icon: 'fa-light fa-user-gear', label: 'tutorDashboard.settings' },
    { to: '/dashboard/subscription', icon: 'fa-light fa-crown', label: 'tutorDashboard.subscription' },
    { to: '/dashboard/help', icon: 'fa-light fa-circle-info', label: 'tutorDashboard.help' },
];

export default function TutorDashboard(){
    const { t } = useTranslation();
    const { user, accessToken } = useSelector((state) => state.authReducer);
 
     // !user ||
  if (!accessToken) {
    return (
      <>
        <Login />
      </>
    );
  }

  if(user.approved==0 && user.teacher_info==''){
    return (
      <>
        <TeacherInfo />
      </>
    );
  }

  if(user.approved==0 && user.teacher_info!=''){
    return (
      <>
        <WaitingApproval />
      </>
    );
  }

    return (
        <div className="dash-shell">
        <DashHeader role="teacher" />
        <div className="page-content student-panel">
          <div className="container">
            <DashMobileNav items={TUTOR_NAV_ITEMS.map((item) => ({ ...item, label: t(item.label) }))} />
            <div className="row">
              <div className="col-xl-3 col-lg-3 panelSidebar">
              <TutorNav/>
              </div>
              <div className="col-lg-9 col-xl-9 col-12">
              <Outlet/>
              </div>
            </div>
          </div>
        </div>
        </div>
    )
}